import React, {useContext} from 'react';

import {SVGAuthors} from '../../../atoms/svgs/authors';
import {MessageContext} from '../../../utils/message';

import {HorizontalSection, VerticalSection, List, LabelField, NameField, DateField} from './ui';

interface Author {
    name: string;
    image?: string;
}

type LayoutDirection = 'inline' | 'block';

export interface ContentWrittenByProps {
    authors: Author[];
    direction?: LayoutDirection;
    showDate?: boolean;
    date?: string;
    className?: string;
}

export const ContentWrittenBy = ({authors, direction = 'inline', showDate = false, date, className}: ContentWrittenByProps) => {
    if (authors.length === 0) {
        return null;
    }

    const {getText} = useContext(MessageContext);

    const names = authors.map((author) => author.name);
    const images = authors.map((author) => author.image);

    const Section = direction === 'inline' ? HorizontalSection : VerticalSection;

    return (
        <Section className={className}>
            {authors.length > 0 && <SVGAuthors id="authors" overlap={0.25} images={images} />}

            <List>
                <LabelField>{getText('content.writtenby.by')}</LabelField>
                {names.map((name, index, arr) => (
                    <NameField key={`name_${index}`} isLast={arr.length - 1 === index}>
                        {name}
                    </NameField>
                ))}
                {showDate && <DateField>{date}</DateField>}
            </List>
        </Section>
    );
};
